import { get, post, put, deleteApi } from './request'

// ********************（员工管理）********************
// 获取员工列表
function getStaffList(params) {
  return get('/channel_admin/staffs', params)
}

// 创建员工发送验证码
function getStaffVerificationCode(data) {
  return post('/channel_admin/staff/create/send_message', data)
}

// 创建员工
function createStaff(data) {
  return post('/channel_admin/staffs', data)
}

// 修改员工状态
function changeStaffStatus(data) {
  return post('/channel_admin/staff_state', data)
}

// 修改员工角色
function changeStaffRole(data) {
  return post('/channel_admin/staffs/change_role', data)
}

// 查询管理员配置
function getAdminConfig(params) {
  return get('/channel_admin/channel_configs', params)
}

// 修改管理员配置
function changeAdminConfig(data) {
  return post('/channel_admin/channel_configs', data)
}
// 修改员工信息
function changeStaffInfoApi(data) {
  return put('/channel_admin/staffs', data)
}
// 获取员工下拉
function getStaffSelect(params) {
  return get('/channel_admin/staff/target', params)
}
function changeStaffApi(data) {
  return post('/channel_admin/staff/transfer/v2', data)
}
// 获取迁移客户的，客户列表
function getEnterprisers(data) {
  return get('/channel_admin/enterprisers', data)
}

// 获取授权配置信息
function getAuthConfigInfo(params) {
  return get('/channel_admin/config_staff_price', params)
}
// 修改授权配置信息
function updateAuthConfigInfo(data) {
  return post('/channel_admin/config_staff_price', data)
}

// 获取客户详情
function getCustomerDetailInfo(params) {
  return get('/channel_admin/customers/detail_info', params)
}
// 编辑客户详情
function editCustomerDetailInfo(data) {
  return post('/channel_admin/customers/detail_info', data)
}
// 获取客户跟进详情
function getCustomerDetailFollowUpInfo(params) {
  return get('/channel_admin/customers/follow_up', params)
}

// 获取客户行为记录
function getCustomerDetailBehaviorRecords(params) {
  return get('/channel_admin/customers/behavior_records', params)
}

// 获取客户详情，客户状态，枚举值
function getCustomerStatusList(params) {
  return get('/channel_admin/customer_status_list', params)
}

// ********************（客户管理）********************
// 获取客户列表
function getCustomerList(params) {
  return get('/channel_admin/enterprisers', params)
}

// 添加客户标签
function addCustomerTag(data) {
  return post('/channel_admin/customers/tags', data)
}

// 获取客户标签列表
function getCustomerTagsList(params) {
  return get('/channel_admin/customers/tags', params)
}

// 删除客户标签
function deleteCustomerTag(data) {
  return deleteApi('/channel_admin/customers/tags', data)
}

// 修改客户标签
function updateCustomerTag(data) {
  return put('/channel_admin/customers/tags', data)
}

// 客户标签排序
function sortCustomerTag(data) {
  return post('/channel_admin/customers/tags/sort', data)
}

// 添加客户标签
function addEnterpriseClone(data) {
  return post('/channel_admin/customers/separation', data)  
}

// 获取客户标签列表
function getEnterpriseCloneList(params) {
  return get('/channel_admin/customers/separation', params)
}

// 删除客户标签
function deleteEnterpriseClone(data) {
  return deleteApi('/channel_admin/customers/separation', data)
}

// 修改客户标签
function updateEnterpriseClone(data) {
  return put('/channel_admin/customers/separation', data)
}

// 客户标签排序
function sortEnterpriseClone(data) {
  return post('/channel_admin/customers/separation/sort', data)
}

// 修改客户状态
function changeCustomerStatus(data) {
  return post('/channel_admin/enterpriser_state', data)
}

// 获取邀请码
function requestInviteCode() {
  return get('/channel_admin/invite_code')
}

// 生成邀请码
function requestGenerateInviteCode(data) {
  return post('/channel_admin/invite_code', data)
}
// 短信通知查询
function getChannelSMS(params) {
  return get('/channel_admin/sms_inform_info', params)
}

// 发送短信检测通知
function sendChannelSMS(data) {
  return post('/channel_admin/sms_inform_info', data)
}

// 分配推广员工
function allocation(data) {
  return post('/channel_admin/enterpriser/allocation', data)
}

export {
  getAuthConfigInfo,
  updateAuthConfigInfo,
  getStaffList,
  getStaffVerificationCode,
  createStaff,
  changeStaffStatus,
  changeStaffRole,
  getAdminConfig,
  changeAdminConfig,
  getCustomerList,
  getCustomerTagsList,
  addCustomerTag,
  deleteCustomerTag,
  updateCustomerTag,
  sortCustomerTag,
  changeCustomerStatus,
  changeStaffInfoApi,
  getStaffSelect,
  changeStaffApi,
  getEnterprisers,
  requestInviteCode,
  requestGenerateInviteCode,
  getChannelSMS,
  sendChannelSMS,
  allocation,
  getCustomerDetailInfo,
  editCustomerDetailInfo,
  getCustomerDetailFollowUpInfo,
  getCustomerDetailBehaviorRecords,
  getCustomerStatusList,
  addEnterpriseClone,
  getEnterpriseCloneList,
  deleteEnterpriseClone,
  updateEnterpriseClone,
  sortEnterpriseClone,
}
